import { render } from "./CustomEdge.vue?vue&type=template&id=1fd812b3&scoped=true&lang=pug"
import script from "./CustomEdge.vue?vue&type=script&lang=js"
export * from "./CustomEdge.vue?vue&type=script&lang=js"

import "./CustomEdge.vue?vue&type=style&index=0&id=1fd812b3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd812b3"]])

export default __exports__